export const FETCH_UPDATES = 'FETCH_UPDATES';
export const FETCH_UPDATES_SUCCESS = 'FETCH_UPDATES_SUCCESS';
export const FETCH_UPDATES_ERROR = 'FETCH_UPDATES_ERROR';

export const fetchUpdates = () => ({ type: FETCH_UPDATES });
